module.exports = __webpack_public_path__ + "img/Moderation-icon.865b9061.svg";